// theme.js
export const theme = {
    primaryDark: 'white',
    primaryLight: 'rgba(4, 77, 162, 1)',
    primaryHover: '#e68a35',
    mobile: '576px',
  }